/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { InternalBoolean, internalBooleanFromJSON, internalBooleanToJSON } from "../PUtils";

export const protobufPackage = "";

export interface HebExample {
  governingLaw: string;
  loveIde: InternalBoolean;
}

function createBaseHebExample(): HebExample {
  return { governingLaw: "", loveIde: 0 };
}

export const HebExample = {
  encode(message: HebExample, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.governingLaw !== "") {
      writer.uint32(10).string(message.governingLaw);
    }
    if (message.loveIde !== 0) {
      writer.uint32(16).int32(message.loveIde);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HebExample {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHebExample();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag != 10) {
            break;
          }

          message.governingLaw = reader.string();
          continue;
        case 2:
          if (tag != 16) {
            break;
          }

          message.loveIde = reader.int32() as any;
          continue;
      }
      if ((tag & 7) == 4 || tag == 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HebExample {
    return {
      governingLaw: isSet(object.governingLaw) ? String(object.governingLaw) : "",
      loveIde: isSet(object.loveIde) ? internalBooleanFromJSON(object.loveIde) : 0,
    };
  },

  toJSON(message: HebExample): unknown {
    const obj: any = {};
    message.governingLaw !== undefined && (obj.governingLaw = message.governingLaw);
    message.loveIde !== undefined && (obj.loveIde = internalBooleanToJSON(message.loveIde));
    return obj;
  },

  create<I extends Exact<DeepPartial<HebExample>, I>>(base?: I): HebExample {
    return HebExample.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<HebExample>, I>>(object: I): HebExample {
    const message = createBaseHebExample();
    message.governingLaw = object.governingLaw ?? "";
    message.loveIde = object.loveIde ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
